import NavLogoFooter from "../assets/images/logo/NavLogo_new.png";

// jsPDF's addImage() resolves a plain URL with a *synchronous* XHR
// (jspdf/src/modules/fileloading.js), so every footer draw blocks the main
// thread while the logo is refetched. Resolve it to a data URL once, up front,
// and hand that to addImage instead.
let cachedFooterLogo = null;
let footerLogoPromise = null;

const readBlobAsDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });

export const preloadFooterLogo = () => {
  if (footerLogoPromise) return footerLogoPromise;

  if (typeof fetch !== "function") {
    footerLogoPromise = Promise.resolve(NavLogoFooter);
    return footerLogoPromise;
  }

  footerLogoPromise = fetch(NavLogoFooter)
    .then((res) => {
      if (!res.ok) throw new Error(`Footer logo fetch failed: ${res.status}`);
      return res.blob();
    })
    .then(readBlobAsDataUrl)
    .then((dataUrl) => {
      if (typeof dataUrl === "string" && dataUrl.startsWith("data:")) {
        cachedFooterLogo = dataUrl;
      }
      return cachedFooterLogo || NavLogoFooter;
    })
    .catch(() => NavLogoFooter);

  return footerLogoPromise;
};

// Same image jsPDF would have fetched, minus the blocking request.
// Falls back to the asset URL if the preload has not settled yet.
export const getFooterLogo = () => cachedFooterLogo || NavLogoFooter;

preloadFooterLogo();

export default getFooterLogo;
